import { useState } from 'react';
import { Severity } from '../common/FlashSnackbar';
import { copyJournalText } from '../../lib/helpers/copyJournalText';

export function useJournalCopy() {
  const [flash, setFlash] = useState<{
    msgKey: string;
    severity: Severity;
  } | null>(null);
  // Keep the message after closing so the snackbar doesn't fade out empty
  const [open, setOpen] = useState(false);

  const handleCopy = async () => {
    const ok = await copyJournalText('journal-copy-content');
    setFlash(
      ok
        ? { msgKey: 'journalCopy.success', severity: 'success' }
        : { msgKey: 'journalCopy.error', severity: 'error' }
    );
    setOpen(true);
  };

  const clearFlash = () => setOpen(false);

  return { flash, open, handleCopy, clearFlash };
}
